"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const EmailOutlined_1 = __importDefault(require("@mui/icons-material/EmailOutlined"));
const LocalPhoneOutlined_1 = __importDefault(require("@mui/icons-material/LocalPhoneOutlined"));
const PinDropOutlined_1 = __importDefault(require("@mui/icons-material/PinDropOutlined"));
const MoreHorizOutlined_1 = __importDefault(require("@mui/icons-material/MoreHorizOutlined"));
const material_1 = require("@mui/material");
const helpers_1 = require("../../../common/helpers/helpers");
;
const isMobile = () => helpers_1.Helpers.isMobile.Android() || helpers_1.Helpers.isMobile.iOS();
const CircleCTA = styled_components_1.default.div `
  display: flex;
  position: relative;
  justify-content: start;
  flex-wrap: wrap;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
`;
const Icon = styled_components_1.default.div `
  width: 50px;
  height: 50px;
  text-align: center;
  background-color: ${(props) => `${props.theme.palette.mainAppColor.light}`};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 700px) {
    width: 44px;
    height: 44px;
  }
`;
const Text = styled_components_1.default.div `
  padding: 5px 0;
  text-align: center;
  line-height: 18px;
`;
const CallToActionItem = (props) => {
    const { onClick, text, activeItem, icon, destination, history, location, type, } = props;
    const call = (number) => {
        document.location.href = `tel:${number}`;
    };
    const email = (address) => {
        window.location.href = `mailto:?to=${address}`;
    };
    const goToDestination = () => {
        if (destination === "call" && isMobile()) {
            return call(activeItem.content.phone);
        }
        if (destination === "email" && isMobile()) {
            return email(activeItem.content.email);
        }
        return history.push({
            pathname: `${location.pathname}/${destination}`,
            search: location.search,
        });
    };
    const renderGraphic = () => {
        if (icon.includes("svg")) {
            return (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                    __html: icon,
                } }));
        }
        if (icon === "email") {
            return react_1.default.createElement(EmailOutlined_1.default, { htmlColor: "black" });
        }
        if (icon === "call") {
            return react_1.default.createElement(LocalPhoneOutlined_1.default, { htmlColor: "black" });
        }
        if (icon === "more") {
            return react_1.default.createElement(MoreHorizOutlined_1.default, { htmlColor: "black" });
        }
        return react_1.default.createElement(PinDropOutlined_1.default, { htmlColor: "black" });
    };
    if (type === "circle") {
        return (react_1.default.createElement(CircleCTA, { onClick: onClick || goToDestination },
            react_1.default.createElement(Icon, null, renderGraphic()),
            react_1.default.createElement(Text, null, text)));
    }
    return (react_1.default.createElement(material_1.ListItem, { disablePadding: true, onClick: () => (onClick && onClick()) || goToDestination() },
        react_1.default.createElement(material_1.ListItemButton, null,
            react_1.default.createElement(material_1.ListItemIcon, null, renderGraphic()),
            react_1.default.createElement(material_1.ListItemText, { primary: text }))));
};
exports.default = (0, react_router_dom_1.withRouter)(CallToActionItem);
